import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ErrorModal from '../../../components/errorModal';
import { API_ENDPOINT } from '../../../constants';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { getExtendedPaymentManagement, getHumanReadablePaymentMethod } from '../helper';
import DeleteModal from '../../../components/deleteModal';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class CancelPayment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
                reasonForCancellation: -1,
                note: '',
                cancelUnpaidPaymentRequest: false
            },
            reasonsForCancellation: []

        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    setInitialData = () => {

    }
    getClinicReasonsForCancellation = () => {

        const groupData = this.getGroupData();
        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
        if (!EXTENDED_PAYMENT_MANAGEMENT) return;
        const clinicId = this.props.selectedClinic;
        if (!groupData || !clinicId) return;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;
        const cancellationReasons = cancellationAndRefundSettings?.cancellationReasons || [];
        let reasonsForCancellation = [];
        if (cancellationReasons?.length) {
            reasonsForCancellation = cancellationReasons.map((reason, rIdx) => {
                return {
                    ...reason,
                    key: rIdx
                }
            });
        }
        // reasonsForCancellation.push({ key: 'other', en: 'Other', se: 'Other'.translate('se') })

        let setObj = {
            reasonsForCancellation
        };
        this.setState(setObj)
    }


    get = () => {
        this.getClinicReasonsForCancellation();
    }
    getPaymentData = () => {
        const paymentId = this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/payments/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const payment = result ?? null;
                if (!payment || payment?.currentStatus?.status?.key !== 'UNPAID') {
                    this.onClose();
                    return;
                }
                this.setState({ paymentData: payment }, () => {
                    this.setInitialData();
                })
            })
        } else {
            this.onClose();
        }
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }
    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }
    }




    sendRequest = () => {
        const form = this.state.form;
        const errors = this.checkValidation();
        if (errors) {
            this.setState({ errors: errors })
            return;
        }
        const paymentData = this.state.paymentData;
        const paymentId = paymentData?._id;
        if (!paymentId) {
            return;
        }

        const reasonForCancellation = this.state.reasonsForCancellation?.find(r => String(r.key) === String(form?.reasonForCancellation)) || null;
        const data = {
            note: form?.note && form?.note.trim() ? form?.note.trim() : '',
            reasonForCancellation: reasonForCancellation ? { en: reasonForCancellation.en, se: reasonForCancellation.se } : null,
        }

        this.setState({ loadingUpdate: true }, () => {
            fetch(API_ENDPOINT + `/api/payments/cancel-payment/${paymentId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loadingUpdate: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.onClose();
                    }
                })
            })
        })


    }

    checkValidation = () => {
        const groupData = this.getGroupData();
        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
        const form = this.state.form;
        let errors = {};

        const reasonForCancellation = this.state.reasonsForCancellation?.find(r => String(r.key) === String(form?.reasonForCancellation)) || null;
        const note = form?.note && form?.note.trim() ? form?.note.trim() : '';
        if (!reasonForCancellation && this.state.reasonsForCancellation?.length) errors.reasonForCancellation = 'Reason for cancellation is required'.translate(this.props.lang);
        const isReasonForCancellationOther = reasonForCancellation && (reasonForCancellation?.en?.trim().toLowerCase() === 'other' || reasonForCancellation?.se?.trim().toLowerCase() === 'other');
        if (((!reasonForCancellation && !errors.reasonForCancellation) || isReasonForCancellationOther) && !note) errors.note = 'Note is required'.translate(this.props.lang);



        return Object.keys(errors).length ? errors : null;
    }

    getBasicPaymentInfo = (data) => {
        const currency = data?.currency;
        const paymentData = this.state.paymentData;
        const questionaryName = paymentData?.caseData?.questionaryName ?? '';
        const caseNumber = paymentData?.paymentNumber ?? '';
        const patientName = paymentData?.patientData?.name ?? '';
        const patientSSN = paymentData?.patientData?.ssn ?? '';
        const price = `${paymentData?.amount?.value} ${paymentData?.amount?.currency ?? currency}`;


        let response = {
            questionaryName: questionaryName,
            price: price,
            caseNumber: caseNumber,
            patientName: patientName,
            patientSSN: patientSSN
        };

        return response;
    }
    render() {

        const isOpen = this.props.isOpen;
        const paymentData = this.state.paymentData;

        if (!paymentData) {
            return null;
        }

        const currency = this.getCurrency();
        const paymentMethods = this.state.paymentMethods ?? [];
        const price = this.state.form?.price && Number(this.state.form?.price) ? Number(this.state.form?.price) : 0;
        const errors = this.state.errors ?? {};

        const basicPaymentInfo = this.getBasicPaymentInfo({ currency });

        return (
            <>
                <Modal isOpen={isOpen} centered className='create-payment-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Cancel payment'.translate(this.props.lang)}
                        <div className='modal-header-subtitle'>
                            {'This will cancel the payment request and can not be undone'.translate(this.props.lang)}
                        </div>
                    </ModalHeader>

                    <ModalBody className='create-payment-modal-body'>
                        <Row>
                            <Col lg='12'>
                                <div className='basic-payment-info-wrap'>
                                    <div className='basic-payment-info-item'>
                                        {basicPaymentInfo.questionaryName ? `${basicPaymentInfo.questionaryName} - ` : ''}<span>{basicPaymentInfo.price}</span>
                                    </div>
                                    <div className='basic-payment-info-item'>
                                        {'Case ID'.translate(this.props.lang)}: <span>{basicPaymentInfo.caseNumber}</span>
                                    </div>
                                    <div className='basic-payment-info-item'>
                                        {basicPaymentInfo.patientName} ({basicPaymentInfo.patientSSN})
                                    </div>
                                </div>
                            </Col>



                            {
                                this.state.reasonsForCancellation?.length ?
                                    <Col lg='12'>
                                        <FormGroup className={errors.reasonForCancellation ? 'fg-has-error' : ''}>
                                            <Label>{'Reason for cancellation'.translate(this.props.lang)}</Label>
                                            <Input
                                                type='select'
                                                value={this.state.form?.reasonForCancellation || -1}
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    if (!value) value = -1;
                                                    let form = this.state.form;
                                                    form.reasonForCancellation = value;
                                                    let setObj = { form };
                                                    if (this.state.errors?.reasonForCancellation || this.state.errors?.note) {
                                                        let errors = this.state.errors;
                                                        delete errors.reasonForCancellation;
                                                        delete errors.note;
                                                        setObj.errors = errors;
                                                    }
                                                    this.setState(setObj);
                                                }}
                                            >
                                                <option value={-1}>{'Select reason'.translate(this.props.lang)}</option>
                                                {
                                                    this.state.reasonsForCancellation.map((reason, rIdx) => {
                                                        return <option value={reason.key}>{reason?.[this.props.lang]}</option>
                                                    })
                                                }

                                            </Input>
                                            {errors.reasonForCancellation ? <div className='error-feedback'>{errors.reasonForCancellation}</div> : null}
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                            }

                            <Col lg='12'>
                                <FormGroup className={errors.note ? 'fg-has-error' : ''}>
                                    <Label>{'Note'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='textarea'
                                        value={this.state.form?.note || ''}
                                        style={{ height: 100 }}
                                        onChange={(e) => {
                                            let form = this.state.form;
                                            form.note = e.target.value;
                                            let setObj = { form };
                                            if (this.state.errors?.note) {
                                                let errors = this.state.errors;
                                                delete errors.note;
                                                setObj.errors = errors;
                                            }
                                            this.setState(setObj);
                                        }}
                                    />
                                    {errors.note ? <div className='error-feedback'>{errors.note}</div> : null}
                                </FormGroup>
                            </Col>

                        </Row>





                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>
                        <Button
                            color="primary"
                            onClick={() => this.sendRequest()}
                            disabled={this.state.loadingUpdate}
                        >
                            {'Cancel payment'.translate(this.props.lang)}
                        </Button>
                        <Button color="primary" className='red-button' onClick={() => this.onClose()}>{'Go back'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>





            </>
            // <>
            //     <DeleteModal
            //         lang={this.props.lang}
            //         isOpen={isOpen}
            //         toggle={() => this.onClose()}
            //         handler={() => this.sendRequest()}
            //     >
            //         {'Are you sure you want to cancel this payment? This action cannot be undone.'.translate(this.props.lang)}
            //     </DeleteModal>


            //     {this.state.error ?

            //         <ErrorModal lang={this.props.lang}
            //             isOpen={this.state.error}
            //             toggle={() => this.setState({ error: null })}

            //         >
            //             {this.state.error.translate(this.props.lang)}
            //         </ErrorModal>

            //         : null}

            // </>
        );
    }
}


export default CancelPayment;